"use strict";

exports.__esModule = true;
exports.default = void 0;
var _ImageEditor = _interopRequireDefault(require("./ImageEditor.js"));
exports.default = _ImageEditor.default;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }